import React, { FC } from "react";
import { useSelector } from "react-redux";
import { IconButton } from "@evergis/ui";

import { PresentationToolsContainer } from "./styled";
import { CollapsableContainer, SelectionControlContainer } from "../GeometrySelectionTools/styled";
import { Pagination } from "../../../FeatureCard/components/Pagination/Pagination";
import { MapControlTool } from "../../styled";
import { getLocation } from "../../../../ducks/location/selectors";
import { usePresentationMode } from "../../../../hooks/layout/usePresentationMode";
import { WidgetType } from "../../../FeatureCard/types";
import { RoutePanelName } from "../../../../appConfig/types";

export const PresentationTools: FC = () => {
  const { payload } = useSelector(getLocation);
  const { isPresentationMode, isProjectConfig, togglePresentationMode } = usePresentationMode();

  if (!isPresentationMode) return null;

  const isSharedPresentation = payload.panel === RoutePanelName.Presentation;

  return (
    <PresentationToolsContainer isSharedPresentation={isSharedPresentation}>
      <MapControlTool>
        <CollapsableContainer>
          <SelectionControlContainer withPadding active>
            <Pagination type={WidgetType.Dashboard} />
          </SelectionControlContainer>
        </CollapsableContainer>
      </MapControlTool>
      {!isSharedPresentation && !isProjectConfig && (
        <MapControlTool>
          <CollapsableContainer>
            <IconButton kind="close" onClick={togglePresentationMode} />
          </CollapsableContainer>
        </MapControlTool>
      )}
    </PresentationToolsContainer>
  );
};
